import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

async function deactivateUser(userId: number): Promise<void> {
  await post(`/api/internal-tools/user/${userId}/deactivate`, {});
}

export const useDeactivateUser = (onSuccessCallback?: () => void) => {
  return useToastedMutation({
    mutationFn: deactivateUser,
    successToastMessage: (_data, userId) => `User ${userId} deactivated successfully`,
    errorToastMessage: (_error, userId) => `Failed to deactivate user ${userId}`,
    onSuccess: () => {
      onSuccessCallback?.();
    },
  });
};
